import axios from "axios";
import { extractFormFields } from "../../components/uploaderComponents/helpers/processPDF";

export const addUserPackages = (userPackages, totalPackageRecord) => {
  return {
    type: "ADD_USER_PACKAGES",
    payload: {
      newPackages: userPackages,
      packagePage: 1,
      totalPackageRecord: totalPackageRecord,
    },
  };
};

export const saveUnprocessedNoc = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;
  const customCreateNoc = state.userPackages.customCreateNoc;

  try {
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/save-unprocessed-noc`,
      {
        sessionName: currentSession,
        document: customCreateNoc,
      },
      {
        withCredentials: true,
      }
    );

    return { success: true };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message,
    };
  }
};

export const loadInitNocPrevData = () => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;

  try {
    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/fetch-init-noc-data`,
      {
        sessionName: currentSession,
      },
      {
        withCredentials: true,
      }
    );

    await dispatch({
      type: "UPDATE_CUSTOM_DOCUMENTS_NOC",
      payload: resp?.data?.data,
    });

    return { success: true, data: resp?.data?.data };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message,
      data: {},
    };
  }
};

export const discardPrevNoc = (packageID) => async (dispatch, getState) => {
  const state = getState();
  const currentSession = state.sessions?.currentSession;

  try {
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/custom-documents/noc/discard-noc`,
      {
        currentSession: currentSession,
        packageID: packageID,
      },
      {
        withCredentials: true,
      }
    );

    await dispatch({
      type: "DISCARD_CUSTOM_DOCUMENTS_NOC",
      payload: packageID,
    });

    return { success: true };
  } catch (error) {
    return { success: false, message: error?.response?.data?.message };
  }
};

export const handleLoadNocDocument =
  (packageID, currentProcessingFile) => async (dispatch, getState) => {
    try {
      const state = getState();
      const { customCreateNoc } = state.userPackages;
      let extractedFields = [];
      let temBase64 = "";

      if (customCreateNoc?.packageID !== packageID) {
        return { success: false, message: "Invalid package ID" };
      }

      try {
        temBase64 = customCreateNoc?.temp_base64;

        extractedFields = await extractFormFields(temBase64);
      } catch (error) {
        console.error("Error extracting fields:", error);
        return { success: false, message: "Error extracting fields" };
      }

      const updatedFormattedData = {
        ...customCreateNoc,
        document: {
          ...customCreateNoc.document,
          tempFields: {
            ...currentProcessingFile.document.tempFields,
            formFields:
              Array.isArray(extractedFields) && extractedFields?.length > 0
                ? extractedFields
                : currentProcessingFile.document.tempFields?.formFields || [],
            currentDocument: {
              ...currentProcessingFile.document.tempFields.currentDocument,
              base64File: temBase64,
            },
          },
        },
      };

      await dispatch({
        type: "UPDATE_CUSTOM_DOCUMENTS_NOC",
        payload: updatedFormattedData,
      });

      return {
        success: true,
        message: "",
        data: updatedFormattedData,
      };
    } catch (error) {
      console.error("Error loading document:", error);
      return { success: false, message: error?.response?.data?.message };
    }
  };

export const handleLoadDocument =
  (setLoadDocumentLoading, setCurrentProcessingFile) =>
  async (dispatch, getState) => {
    try {
      const state = getState();
      const { userPackages, selectedPackage, selectedPackageForm } =
        state.userPackages;
      if (
        (selectedPackage && selectedPackage?.documents?.length === 0) ||
        (selectedPackageForm && !selectedPackageForm?.formID) ||
        !selectedPackageForm
      ) {
        return;
      }

      setLoadDocumentLoading(true);

      let base64PDF = null;
      let extractedFields = [];

      // ✅ Get the freshest package state
      const freshPkg = userPackages.find(
        (pkg) => pkg.packageID === selectedPackage?.packageID
      );

      const freshForm = freshPkg?.documents?.find(
        (doc) => doc.formID === selectedPackageForm?.formID
      );

      if (!freshPkg || !freshForm) {
        console.error("Fresh package or form not found.");
        return;
      }

      const selectedPackageCopy = { ...freshPkg };
      delete selectedPackageCopy.documents;

      const formattedData = {
        ...selectedPackageCopy,
        signers: freshPkg?.signers || {},
        document: freshForm,
      };

      if (!formattedData?.document?.tempFields?.currentDocument?.base64File) {
        const fieldResp = await dispatch(
          fetchUserPkgFileBase64(
            formattedData.document.pdf_url,
            formattedData.packageID,
            formattedData.document.formID
          )
        );

        base64PDF = fieldResp.base64;
        extractedFields = fieldResp.extractedFields;
      } else {
        base64PDF =
          formattedData.document.tempFields.currentDocument.base64File;
      }

      const updatedFormattedData = {
        ...formattedData,
        document: {
          ...formattedData.document,
          tempFields: {
            ...formattedData.document.tempFields,
            formFields:
              Array.isArray(extractedFields) && extractedFields?.length > 0
                ? extractedFields
                : formattedData.document.tempFields?.formFields || [],
            currentDocument: {
              ...formattedData.document.tempFields.currentDocument,
              base64File: base64PDF,
            },
          },
          actions: formattedData.document.actions, // ✅ keep these
          locked: formattedData.document.locked,
          document_name: formattedData.document.document_name,
        },
      };

      const updatedPackageData = {
        ...freshPkg,
        signers: freshPkg?.signers || {},
        documents: freshPkg.documents.map((doc) =>
          doc.formID === formattedData.document.formID
            ? {
                ...doc,
                tempFields: {
                  ...doc.tempFields,
                  formFields:
                    Array.isArray(extractedFields) &&
                    extractedFields?.length > 0
                      ? extractedFields
                      : doc.tempFields?.formFields || [],
                  currentDocument: {
                    ...doc.tempFields.currentDocument,
                    base64File: base64PDF,
                  },
                },
              }
            : doc
        ),
      };

      const updatedSelectedForm = updatedPackageData.documents.find(
        (doc) => doc.formID === formattedData.document.formID
      );

      await setCurrentProcessingFile(updatedFormattedData);
      dispatch(updateSelectedPackageObject(updatedPackageData));
      dispatch(updateSelectedPackageFormObject(updatedSelectedForm));
    } catch (error) {
      console.error("Error loading document:", error);
    } finally {
      setLoadDocumentLoading(false);
    }
  };

export const clearCustomCreateNoc = () => {
  return {
    type: "CLEAR_CUSTOM_CREATE_NOC",
    payload: {},
  };
};

export const uploadCustomNocPDF =
  (currentProcessingFile, setUploaderLoading) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const errorMarkedFile = state.userPackages.errorMarkedFile;

    try {
      const formData = new FormData();

      formData.append("currentSession", currentSession);

      formData.append(
        "stringActions",
        JSON.stringify(currentProcessingFile.document.actions)
      );

      const document =
        currentProcessingFile.document.tempFields.currentDocument;

      if (document?.base64File) {
        // Send Base64 data as a normal field
        formData.append("base64File", document.base64File);
      }

      if (document?.fileName) {
        formData.append("fileName", document.fileName);
      }

      if (document?.files?.length > 0) {
        document.files.forEach((file) => {
          formData.append("files", file); // Automatically sends as multipart
        });
      }

      const bypassError = document?.fileName === errorMarkedFile;
      formData.append("bypassError", bypassError);

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/custom-documents/noc/upload-pdf`,
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const formattedData = {
        package_type: "noc",
        packageID: resp.data.data.packageID,
        email: resp.data.data.email,
        is_subuser: resp.data.data.is_subuser,
        user_document_token: resp.data.data.user_document_token,
        status: resp.data.data.status,
        payments: resp.data.data.payments,
        document_location: resp.data.data.document_location,
        signer: resp.data.data.signer,
        contractor: resp.data.data.contractor,
        processing_permit: resp.data.data.processing_permit,
        document: {
          ...resp.data.data.document, // Keep document properties
          actions: currentProcessingFile.document.actions,
          tempFields: currentProcessingFile.document.tempFields,
        },
      };

      await dispatch({
        type: "ADD_CUSTOM_DOCUMENTS_NOC",
        payload: formattedData,
      });
      await dispatch({
        type: "UPDATE_ERROR_MARKED_FILE",
        payload: "",
      });

      return { success: true, message: "", data: formattedData };
    } catch (error) {
      dispatch({
        type: "UPDATE_ERROR_MARKED_FILE",
        payload:
          currentProcessingFile.document.tempFields.currentDocument.fileName,
      });
      return { success: false, message: error?.response?.data?.message };
    } finally {
      setUploaderLoading(false);
    }
  };

export const uploadUserPackagePDF =
  (currentProcessingFile, setUploaderLoading, packageName, packageID) =>
  async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      const formData = new FormData();

      formData.append("currentSession", currentSession);
      formData.append("packageID", packageID ?? "");
      formData.append("packageName", packageName ?? "");

      const document =
        currentProcessingFile.document.tempFields.currentDocument;

      if (document?.base64File) {
        // Send Base64 data as a normal field
        formData.append("base64File", document.base64File);
      }

      if (document?.fileName) {
        formData.append("fileName", document.fileName);
      }

      if (document?.files?.length > 0) {
        document.files.forEach((file) => {
          formData.append("files", file); // Automatically sends as multipart
        });
      }

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/upload-pdf`,
        formData,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (packageID) {
        const newDocument = {
          ...resp.data.data, // Use new document data from response
          tempFields: {
            ...currentProcessingFile.document.tempFields,
            currentDocument: {
              ...currentProcessingFile.document.tempFields.currentDocument,
              files: undefined, // Exclude `files`
            },
          },
        };

        const returnDoc = {
          ...resp.data.data,
          tempFields: currentProcessingFile.document.tempFields,
        };

        await dispatch({
          type: "ADD_DOCUMENTS_TO_PACKAGE",
          payload: {
            packageID: packageID,
            documents: [newDocument], // ✅ Append new document to existing package
            formPage: 1, // Assuming we start with page 1
            totalFormRecord: 1, // Can be updated dynamically
          },
        });

        return returnDoc;
      } else {
        const formattedData = {
          packageID: resp.data.data.packageID,
          packageName: resp.data.data.packageName,
          email: resp.data.data.email,
          is_subuser: resp.data.data.is_subuser,
          user_document_token: resp.data.data.user_document_token,
          status: resp.data.data.status,
          payments: resp.data.data.payments,
          document_location: resp.data.data.document_location,
          signers: resp.data.data.signers,
          processing_permit: resp.data.data.processing_permit,
          documents: [
            {
              ...resp.data.data.documents[0], // Keep document properties
              tempFields: currentProcessingFile.document.tempFields,
            },
          ],
        };

        const modifiedData = {
          ...formattedData,
          document: formattedData.documents[0], // Extract first (only) item
        };
        delete modifiedData.documents;

        const reduxData = {
          ...formattedData,
          documents: [
            {
              ...resp.data.data.documents[0], // Keep document properties
              tempFields: {
                ...currentProcessingFile.document.tempFields,
                currentDocument: {
                  ...currentProcessingFile.document.tempFields.currentDocument,
                  files: undefined, // Exclude `files`
                },
              },
            },
          ],
        };

        await dispatch({
          type: "ADD_NEW_USER_PACKAGE",
          payload: reduxData,
        });

        return modifiedData;
      }
    } catch (error) {
    } finally {
      setUploaderLoading(false);
    }
  };

export const fetchMoreUserPackages = async (
  dispatch,
  sessionName,
  currentPage,
  totalPackages
) => {
  if (totalPackages && currentPage * 5 >= totalPackages) return; // ✅ Prevent extra fetch if no more packages

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/initial-load`,
      {
        sessionName: sessionName,
        pagination: {
          package: {
            packageLimit: 5,
            packagePage: currentPage + 1,
            totalPackageRecord: totalPackages,
          },
          form: { formLimit: 5, formPage: 1, totalFormRecord: 0 },
        },
      },
      { withCredentials: true }
    );

    const { totalPackageRecord, userPackages } = response.data;

    dispatch({
      type: "ADD_USER_PACKAGES",
      payload: {
        newPackages: userPackages,
        packagePage: currentPage + 1,
        totalPackageRecord: totalPackageRecord,
      },
    });
  } catch (error) {
    console.error("Error fetching more user packages:", error);
  }
};

export const fetchMoreUserPackageDocuments = async (
  dispatch,
  packageID,
  currentPage,
  totalForms
) => {
  if (totalForms && currentPage * 5 >= totalForms) return; // ✅ Prevent extra fetch if no more documents

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/fetch-documents`,
      {
        packageID: packageID,
        pagination: {
          formLimit: 5,
          formPage: currentPage + 1,
          totalFormRecord: totalForms,
        },
      },
      { withCredentials: true }
    );

    const { totalFormRecord, documents } = response.data;

    dispatch({
      type: "ADD_DOCUMENTS_TO_PACKAGE",
      payload: {
        packageID: packageID,
        documents: documents,
        formPage: currentPage + 1,
        totalFormRecord: totalFormRecord,
      },
    });
  } catch (error) {
    console.error("Error fetching more documents:", error);
  }
};

export const fetchUserPkgFileBase64 =
  (pdfURL, packageID, formID) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/fetch-pdf`,
        {
          pdfURL: pdfURL,
          currentSession: currentSession,
        },
        { withCredentials: true }
      );

      if (response?.data?.pdf_base64) {
        const extractedFields = await extractFormFields(
          response?.data?.pdf_base64
        );

        await dispatch({
          type: "ADD_BASE64_TO_PACKAGE",
          payload: {
            BASE64: response?.data?.pdf_base64,
            packageID: packageID,
            formID: formID,
            formFields: extractedFields,
          },
        });

        return {
          base64: response?.data?.pdf_base64,
          extractedFields: extractedFields,
        };
      } else return { base64: "", extractedFields: [] };
    } catch (error) {
      console.error("Error fetching PDF as Base64:", error);
      return null;
    }
  };

export const updatePackageAndSelect = (updatedPackage) => ({
  type: "UPDATE_PACKAGE_AND_SELECT",
  payload: updatedPackage,
});

export const updateSelectedPackageObject = (packageObject) => ({
  type: "UPDATE_SELECTED_PACKAGE_OBJECT",
  payload: packageObject,
});

export const updateSelectedPackageFormObject = (formObject) => ({
  type: "UPDATE_SELECTED_PACKAGE_FORM_OBJECT",
  payload: formObject,
});

export const updateSelectedPackage = (packageID) => ({
  type: "UPDATE_SELECTED_PACKAGE",
  payload: packageID,
});

export const updateSelectedPackageWithForm = (packageID, formID) => ({
  type: "UPDATE_SELECTED_PACKAGE_WITH_FORM",
  payload: { packageID, formID },
});

export const toggleImSigner = (packageID, signerKey, signerFields = {}) => ({
  type: "TOGGLE_IM_SIGNER",
  payload: { packageID, signerKey, signerFields },
});

export const emptySigner = (packageID, signerKey) => ({
  type: "EMPTY_SIGNER",
  payload: { packageID, signerKey },
});

export const updateSignerField = (packageID, signerKey, field, value) => ({
  type: "UPDATE_SIGNER_FIELD",
  payload: { packageID, signerKey, field, value },
});

export const updateEditingForm =
  (currentProcessingFile) => async (dispatch, getState) => {
    await dispatch({
      type: "UPDATE_EDITING_FORM",
      payload: currentProcessingFile,
    });

    return true;
  };

export const updateProcessOptions = (packageID, formID, options) => {
  return {
    type: "UPDATE_PROCESS_OPTIONS",
    payload: {
      packageID: packageID,
      formID: formID,
      options: options,
    },
  };
};

export const removeFixedField = (packageID, formID, prefix) => {
  return {
    type: "REMOVE_FIXED_FIELDS",
    payload: {
      packageID: packageID,
      formID: formID,
      prefix: prefix,
    },
  };
};

export const updatePackageName =
  (packageID, newName) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/edit-package-name`,
        {
          currentSession: currentSession,
          packageID: packageID,
          newName: newName,
        },
        { withCredentials: true }
      );

      await dispatch({
        type: "UPDATE_PACKAGE_NAME",
        payload: {
          packageID: packageID,
          value: newName,
        },
      });
    } catch (e) {}
  };

export const updateDocName =
  (packageID, formID, newName) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/edit-doc-name`,
        {
          currentSession: currentSession,
          packageID: packageID,
          docID: formID,
          newName: newName,
        },
        { withCredentials: true }
      );

      await dispatch({
        type: "UPDATE_DOC_NAME",
        payload: {
          packageID: packageID,
          docID: formID,
          value: newName,
        },
      });
    } catch (e) {}
  };

export const updateNewFileName =
  (packageID, formID, newName) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/edit-doc-filename`,
        {
          currentSession: currentSession,
          packageID: packageID,
          docID: formID,
          newName: newName,
        },
        { withCredentials: true }
      );

      await dispatch({
        type: "UPDATE_DOC_FILENAME",
        payload: {
          packageID: packageID,
          docID: formID,
          value: newName,
        },
      });
    } catch (e) {}
  };

export const deleteUserPackageForm =
  (packageID, formID, savedPackagesActive) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const userPackages = state.userPackages?.userPackages;

    try {
      const hasDocuments = userPackages?.some(
        (pkg) => pkg.packageID === packageID && pkg.documents?.length > 0
      );

      if (savedPackagesActive && hasDocuments) {
        return false;
      }

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/delete-doc`,
        {
          currentSession: currentSession,
          packageID: packageID,
          docID: formID,
          remove_package: savedPackagesActive,
        },
        { withCredentials: true }
      );

      if (savedPackagesActive) {
        await dispatch({
          type: "DELETE_USER_PACKAGE",
          payload: {
            packageID: packageID,
          },
        });
      } else {
        await dispatch({
          type: "DELETE_USER_PACKAGE_DOCUMENT",
          payload: {
            packageID: packageID,
            docID: formID,
            removePackage: savedPackagesActive,
          },
        });
      }

      return true;
    } catch (e) {
      console.error("Error deleting user package form:", e);
    }
  };

export const updateTempFields = (payload) => {
  return {
    type: "UPDATE_TEMP_FIELDS",
    payload: payload,
  };
};

export const lockDocument =
  (selectedPackage, formID, document) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/lock-document`,
        {
          currentSession: currentSession,
          selectedPackage: selectedPackage,
          docID: formID,
          document: document,
        },
        { withCredentials: true }
      );

      if (resp?.data?.success) {
        await dispatch({
          type: "TOGGLE_DOCUMENT_LOCK",
          payload: {
            packageID: selectedPackage?.packageID,
            docID: formID,
            locked: true,
          },
        });

        // 🔐 Only call if there's a valid PDF URL
        if (resp?.data?.pdf_url) {
          await dispatch(
            fetchUserPkgFileBase64(
              resp?.data?.pdf_url,
              selectedPackage?.packageID,
              formID
            )
          );
        }

        return { success: true, locked: true };
      } else {
        return { success: false, locked: true, nessage: resp?.data?.message };
      }
    } catch (e) {
      return false;
    }
  };

export const unlockDocument =
  (packageID, formID) => async (dispatch, getState) => {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/unlock-document`,
        {
          currentSession: currentSession,
          packageID: packageID,
          docID: formID,
        },
        { withCredentials: true }
      );

      if (resp?.data?.success) {
        await dispatch({
          type: "TOGGLE_DOCUMENT_LOCK",
          payload: {
            packageID: packageID,
            docID: formID,
            locked: false,
          },
        });

        return { success: true, locked: false };
      } else {
        return { success: false, locked: true, nessage: resp?.data?.message };
      }
    } catch (e) {
      return false;
    }
  };

export const addSignature = (signPack) => {
  return { type: "ADD_SIGNATURE", payload: signPack };
};
